import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from 'utils/user';
import { BillingStatus, Payment } from './types';

export const apiPayments = createApi({
  reducerPath: 'paymentsApi',
  tagTypes: ['Payment'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${getApiBaseUrl()}/`,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('X-Client', 'web');
      return headers;
    },
  }),
  endpoints: builder => ({
    getBilling: builder.query<BillingStatus, void>({
      query: () => 'payments/billing',
      transformResponse: (data: BillingStatus) => data,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['Payment'],
    }),
    getPayments: builder.query<Payment[], void>({
      query: () => 'payments',
      transformResponse: (data: { payments: Payment[] }) => data.payments,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['Payment'],
    }),
    getPayment: builder.query<Payment, string>({
      query: id => `payments/${id}`,
      transformResponse: (data: { payment: Payment }) => data.payment,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['Payment'],
    }),
    addPayment: builder.mutation<Payment, Partial<Payment>>({
      query: body => ({
        url: `payments`,
        method: 'POST',
        body,
      }),
      transformResponse: (data: { payment: Payment }) => data.payment,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      invalidatesTags: ['Payment'],
    }),
    createPaymentIntent: builder.mutation<string, void>({
      query: () => ({
        url: 'payments/intent',
        method: 'POST',
      }),
      transformResponse: (data: { clientSecret: string }) => data.clientSecret,
      transformErrorResponse: (response: { status: string | number }) => response.status,
    }),
  }),
});

export const {
  useGetBillingQuery,
  useGetPaymentsQuery,
  useLazyGetPaymentQuery,
  useAddPaymentMutation,
  useCreatePaymentIntentMutation,
} = apiPayments;
